/* eslint-disable no-unused-vars */
import { useState } from 'react';
import {
  Backdrop, Box, Button,
  Fade, Icon,
  makeStyles, Modal, Typography,
} from '@material-ui/core';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  modal: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 457,
    background: theme.palette.background.default,
    padding: theme.spacing(1, 1, 2, 2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderRadius: 14,
  },
  infoIncon: {
    color: theme.palette.text.blue,
    fontSize: 80,
  },
  closeIcon: {
    color: theme.palette.text.blue,
    fontSize: 30,
    alignSelf: 'flex-end',
    margin: theme.spacing(0, 0, 2, 3),
  },
  textBody: {
    color: theme.palette.text.blue,
    textAlign: 'center',
    fontSize: 20,
    fontWeight: 500,
    fontFamily: 'Raleway',
    margin: theme.spacing(3, 1, 1, 1),
  },
  buttonModal: {
    backgroundColor: theme.palette.background.secondary,
    color: theme.palette.text.default,
    margin: theme.spacing(2, 0),
    '&:hover': {
      background: theme.palette.background.secondary,
    },
  },
}));

export default function TransitionsModal({
  open, actionButton, textBody, textButton, handleClose, icon, showCloseModalIcon,
}) {
  const classes = useStyles();

  const [isLoading, setIsLoading] = useState(false);

  const actionButtonModal = async () => {
    setIsLoading(true);
    await actionButton();
    setIsLoading(false);
    handleClose();
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 700,
        }}
      >
        <Fade in={open}>
          <Box className={classes.modal}>
            {showCloseModalIcon
              ? <HighlightOffIcon className={classes.closeIcon} onClick={() => handleClose()} />
              : null}
            <Icon className={classes.infoIncon}>
              {icon(classes.infoIncon)}
            </Icon>
            <Typography className={classes.textBody}>{textBody}</Typography>
            { textButton === ''
              ? <Box />
              : isLoading
                ? (
                  <Button
                    variant="contained"
                    disabled
                    className={classes.buttonModal}
                  >
                    CARGANDO...
                  </Button>
                )
                : (
                  <Button
                    variant="contained"
                    onClick={() => actionButtonModal()}
                    className={classes.buttonModal}
                  >
                    { textButton }
                  </Button>
                )}
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}

TransitionsModal.propTypes = {
  textButton: PropTypes.string,
  open: PropTypes.bool.isRequired,
  actionButton: PropTypes.func,
  textBody: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
  icon: PropTypes.func.isRequired,
  showCloseModalIcon: PropTypes.bool,
};

TransitionsModal.defaultProps = {
  textButton: '',
  actionButton: null,
  showCloseModalIcon: true,
};
